export const styles = {
  odd: (theme) => ({
    backgroundColor: theme.palette.common.white,

    '.MuiAccordionSummary-root': {
      backgroundColor: theme.palette.common.white,
    },
  }),
  even: ({ palette }) => ({
    backgroundColor: palette.accentFade.main,
  }),
};
